<script lang="ts">
    import {router} from 'tinro';


    import List, {Item, Graphic, Separator, Text, PrimaryText, SecondaryText} from '@smui/list'
    import Textfield from '@smui/textfield'
    import Icon from '@smui/textfield/icon'

    import {deep_copy, newId} from "./jmdb"
    import type {GroupSchema, ReadyList, Named} from './jmdb'
    
    import { onDestroy } from 'svelte';

    import GroupEditor from './GroupEditor.svelte'

    export let schema: GroupSchema<any, any>
    export let group_id: string = ''

    let newGroupSelected = false
    $: newGroupSelected = (group_id == newId.toString())

    let filterText = ''
    let selectedGroup: any | undefined
    let group_list_sorted: ReadyList<any>
    
    onDestroy(schema.group_store.subscribe((val) => {
        // map(v=>v) is for creating a clone
        group_list_sorted = {ready: val.ready, data: val.data.map(v=>v).sort((a, b) => a.name.localeCompare(b.name))}     
    }))

    let elements: ReadyList<Named> = {ready: false, data: []}
    onDestroy(schema.element_store.subscribe((val) => {
        // map(v=>v) is for creating a clone
        elements = {ready: val.ready, data: val.data}
    }))

    let emptyGrp: any = {id: newId}
    emptyGrp[schema.group_key] = []
    $: selectedGroup = newGroupSelected ? emptyGrp : (group_list_sorted.data.find((v) => v.id == Number(group_id)) || undefined)

    function accessGroupKey(grp: any): string[] {
        let entries: number[] = grp[schema.group_key]
        return entries.map(v=>v.toString())
    }

    schema.group_store.fetch()
    schema.element_store.fetch()
</script>

{schema.name}

<div class="row">
    <div class="col-md-3">
        <div style="display: flex; flex-wrap: nowrap;">
            <Textfield withLeadingIcon label="Find" bind:value={filterText} >
                <Icon class="material-icons">search</Icon>
            </Textfield>
        </div>

    </div>
</div>
<div class="row">
    <div class="col-md-3 user-list">
        {#if !group_list_sorted.ready}
            Loading...
        {:else}
            <List singleSelection>
                {#each group_list_sorted.data as actor}
                {#if (!filterText || actor.name.toLowerCase().indexOf(filterText.toLowerCase()) != -1)}
                <Item selected={actor.id == Number(group_id)}>
                    <a class="divLink" href="/mgr/{schema.rel_path}/{actor.id}">&nbsp;</a>
                    <Text>{actor.name}</Text>
                </Item>
                <Separator />
                {/if}
                {/each}
            </List>
            <List singleSelection>
                <Item selected={newGroupSelected}>
                    <a class="divLink" href="/mgr/{schema.rel_path}/{newId}">&nbsp;</a>
                    <Graphic class="material-icons">add</Graphic>
                    <Text>New group</Text>
                </Item>
            </List>
        {/if}
    </div>
    <div class="col-md-9">
        {#if !selectedGroup }
            Nothing is selected
        {:else}
            {#key selectedGroup}
                <GroupEditor elements={elements} selected={deep_copy(selectedGroup)} schema={schema} />
            {/key}
        {/if}
    </div>

</div>